export const refs = {
  headerBurger: document.querySelector('.header__burger'),
  headerMenu: document.querySelector('.header__menu'),
  body: document.querySelector('body'),
  searchIcon: document.querySelector('.search__icon'),
  headerSearch: document.querySelector('.header__search'),
  form: document.querySelector('.search__form'),
};
